import Carousel from 'bootstrap/js/src/carousel';
import ScrollCarouselDots from '../../../base/js/components/ScrollCarouselDots';

const SCROLL_CAROUSEL_ACTIVE_MARKER = '--scp-scroll-carousel-active',
	  ACTIVE_MARKER_VALUE = '1',
	  RESIZE_DEBOUNCE_MS = 150,
	  TOP_OFFERS_CAROUSEL_SELECTOR = '.container.offers .row.sortableToBoxContainer .top_offers .carousel',
	  SHARED_DOTS_CLASS_NAME = 'scpCarousel-dots',
	  SHARED_DOT_CLASS_NAME = 'scpCarousel-dot';

export {TOP_OFFERS_CAROUSEL_SELECTOR};

export default class ScpHomepageCarousels {
	constructor() {
		this.initScrollCarouselDots();
		this.topOffersCarousel = document.querySelector(TOP_OFFERS_CAROUSEL_SELECTOR);

		if (!this.topOffersCarousel) {
			return;
		}

		this.syncTopOffersMode();
		window.addEventListener('resize', this.debounce(this.syncTopOffersMode.bind(this), RESIZE_DEBOUNCE_MS));
	}

	initScrollCarouselDots() {
		new ScrollCarouselDots({
			'scrollContainerSelector': '.container.offers .row.sortableToBoxContainer .top_matches .item-container',
			'cardSelector'           : '.item',
			'markerProperty'         : SCROLL_CAROUSEL_ACTIVE_MARKER,
			'dotsClassName'          : SHARED_DOTS_CLASS_NAME,
			'dotClassName'           : SHARED_DOT_CLASS_NAME
		});
		new ScrollCarouselDots({
			'scrollContainerSelector': `${TOP_OFFERS_CAROUSEL_SELECTOR} .carousel-inner`,
			'cardSelector'           : '.carousel-item',
			'markerProperty'         : SCROLL_CAROUSEL_ACTIVE_MARKER,
			'dotsClassName'          : SHARED_DOTS_CLASS_NAME,
			'dotClassName'           : SHARED_DOT_CLASS_NAME
		});
		new ScrollCarouselDots({
			'scrollContainerSelector': '.container.popular_events .clubsContainer',
			'cardSelector'           : '.club',
			'markerProperty'         : SCROLL_CAROUSEL_ACTIVE_MARKER,
			'dotsClassName'          : SHARED_DOTS_CLASS_NAME,
			'dotClassName'           : SHARED_DOT_CLASS_NAME
		});
	}

	syncTopOffersMode() {
		const bootstrapCarousel = Carousel.getInstance(this.topOffersCarousel);

		if (this.isNativeScrollMode()) {
			bootstrapCarousel?.dispose();

			return;
		}

		if (!bootstrapCarousel) {
			Carousel.getOrCreateInstance(
				this.topOffersCarousel,
				{
					'interval': false
				}
			);
		}
	}

	isNativeScrollMode() {
		const markerValue = getComputedStyle(this.topOffersCarousel)
			.getPropertyValue(SCROLL_CAROUSEL_ACTIVE_MARKER)
			.trim();

		return markerValue === ACTIVE_MARKER_VALUE;
	}

	debounce(callback, waitMs) {
		let timeoutId;

		return (...args) => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => callback(...args), waitMs);
		};
	}
}